// import Vue from 'vue'
// import VeeValidate, {Validator} from 'vee-validate'
// import tr from 'vee-validate/dist/locale/tr'
// import ibanValidator from './iban'
// import tcValidator from './tc'


// Vue.use(VeeValidate)
// Validator.localize('tr', tr)

// ibanValidator.init();
// tcValidator.init();

import Vue from 'vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

import './rules'


// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);